var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _circle2, _circle3, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle5, _circle6, _circle7, _circle8, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle9, _circle0, _circle1, _circle10, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _circle11, _circle12, _circle13, _circle14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "aiIcon_svg__ai-pink-gradient",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#ff6cac",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#ff6cac",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aiIcon_svg__ai-purple-gradient",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#c402a4",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#c402a4",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aiIcon_svg__ai-orange-gradient",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#ff8e76",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#ff8e76",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aiIcon_svg__ai-yellow-gradient",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#ffa74e",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#ffa74e",
    stopOpacity: 1
  }
})), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes drawLineForwardBackward{0%,to{stroke-dashoffset:100}50%{stroke-dashoffset:-20}}@keyframes circleSyncWithLines{0%,to{opacity:.6}50%{opacity:1}}@keyframes pulse{0%,to{opacity:1}50%{opacity:.6}}.aiIcon_svg__ai-line{stroke-dasharray:100;stroke-dashoffset:100;animation:drawLineForwardBackward 10s ease-in-out infinite;stroke-width:1.5}.aiIcon_svg__ai-line-delay-1{animation-delay:.2s}.aiIcon_svg__ai-line-delay-2{animation-delay:.4s}.aiIcon_svg__ai-line-delay-3{animation-delay:.6s}.aiIcon_svg__ai-line-delay-4{animation-delay:.8s}.aiIcon_svg__ai-line-delay-5{animation-delay:1s}.aiIcon_svg__ai-line-delay-6{animation-delay:1.2s}.aiIcon_svg__ai-circle{opacity:.8;animation:circleSyncWithLines 10s ease-in-out infinite;fill:none;stroke-width:1.5}.aiIcon_svg__ai-circle-delay-1{animation-delay:1.4s}.aiIcon_svg__ai-circle-delay-2{animation-delay:1.6s}.aiIcon_svg__ai-circle-delay-3{animation-delay:1.8s}.aiIcon_svg__ai-circle-delay-4{animation-delay:2s}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "aiIcon_svg__ai-title"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  x: 27.5,
  y: 27.5,
  stroke: "#ff6cac",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  x: 23,
  y: 23,
  stroke: "#ff6cac",
  strokeWidth: 2,
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6cac",
  d: "M33.296 47H30l5.022-14h3.963L44 47h-3.296L37.06 36.2h-.113zm-.206-5.503h7.785v2.31H33.09zM45 33h3v14h-3z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M52 22v-3l3-1.732V12",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M42.5 22v-6.5l4-2.31V6",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M37.5 22v-4L35 15.5v-5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M27.5 22v-2.5l-2-2V8",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M32.5 22v-4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M47 22v-3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-6"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M49.5 22v-6l2-1.155V13",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M45 22v-5.5l4-2.31V8",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M40 22v-6l-2-2v-3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M35 22v-4l-2.5-2.5V12",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M30 22v-6l-2-2v-4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 46.5,
  cy: 4.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-1"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 55.5,
  cy: 10.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-2"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.5,
  cy: 8.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-3"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 6.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-4"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M22 29h-3l-1.732-3H12",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M22 38.5h-6.5l-2.31-4H6",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M22 43.5h-4L15.5 46h-5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M22 53.5h-2.5l-2 2H8",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M22 48.5h-4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M22 34h-3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-6"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M22 31.5h-6l-1.155-2H13",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M22 36h-5.5l-2.31-4H8",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M22 41h-6l-2 2h-3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M22 46h-4l-2.5 2.5H12",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M22 51h-6l-2 2h-4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 34.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-1",
  transform: "rotate(-90 4.5 34.5)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 25.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-2",
  transform: "rotate(-90 10.5 25.5)"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 46.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-3",
  transform: "rotate(-90 8.5 46.5)"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 55.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-4",
  transform: "rotate(-90 6.5 55.5)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M29 57.5v3l-3 1.732V67.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M38.5 57.5V64l-4 2.31v7.19",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M43.5 57.5v4L46 64v5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M53.5 57.5V60l2 2v9.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M48.5 57.5v4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M34 57.5v3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-6"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M31.5 57.5v6l-2 1.155V66.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M36 57.5V63l-4 2.31v6.19",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M41 57.5v6l2 2v3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M46 57.5v4l2.5 2.5v3.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M51 57.5v6l2 2v4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.5,
  cy: 75,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-1",
  transform: "rotate(-180 34.5 75)"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 69,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-2",
  transform: "rotate(-180 25.5 69)"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.5,
  cy: 71,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-3",
  transform: "rotate(-180 46.5 71)"
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 55.5,
  cy: 73,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-4",
  transform: "rotate(-180 55.5 73)"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M57.5 52h3l1.732 3H67.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M57.5 42.5H64l2.31 4h7.19",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M57.5 37.5h4L64 35h5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M57.5 27.5H60l2-2h9.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M57.5 32.5h4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  d: "M57.5 47h3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-6"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M57.5 49.5h6l1.155 2H66.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-1"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M57.5 45H63l2.31 4h6.19",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-2"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  d: "M57.5 40h6l2-2h3",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-3"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  d: "M57.5 35h4l2.5-2.5h3.5",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-4"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  d: "M57.5 30h6l2-2h4",
  className: "aiIcon_svg__ai-line aiIcon_svg__ai-line-delay-5"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 46.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-pink-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-1",
  transform: "rotate(90 75 46.5)"
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 55.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-purple-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-2",
  transform: "rotate(90 69 55.5)"
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 34.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-orange-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-3",
  transform: "rotate(90 71 34.5)"
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 25.5,
  r: 2,
  stroke: "url(#aiIcon_svg__ai-yellow-gradient)",
  strokeWidth: 1.5,
  className: "aiIcon_svg__ai-circle aiIcon_svg__ai-circle-delay-4",
  transform: "rotate(90 73 25.5)"
})));
export default SvgAiIcon;